import { render, staticRenderFns } from "./NewEditDetail.vue?vue&type=template&id=4d1f7ee0&"
import script from "../../models/app-design/new-edit-detail.ts?vue&type=script&lang=ts&"
export * from "../../models/app-design/new-edit-detail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports